import { call, put, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../utilz';
import {
  getAwardedBidsInError,
  getAwardedBidsInSuccess,
  getLastSevenDaysDataInError,
  getLastSevenDaysDataInSuccess,
  getOpenBidsAgingInError,
  getOpenBidsAgingInSuccess,
  getOpenBidsInError,
  getOpenBidsInSuccess,
  getOverallTimeLineInError,
  getOverallTimeLineInSuccess,
} from './DashboardActions';
import {
  getAwardedBidsEffect,
  getOpenBidsAgingEffect,
  getOpenBidsEffect,
  getOverAllTimelineEffect,
  getSevenDaysDataEffect,
} from './DashboardEffects';
import DashboardTypes from './DashboardTypes.ts';

function* getOpenBids({ payload }) {
  try {
    const { data } = yield call(getOpenBidsEffect, payload);
    yield put(getOpenBidsInSuccess({ data: data }));
  } catch (e) {
    yield put(getOpenBidsInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getSevenDaysData({ payload }) {
  try {
    const { data } = yield call(getSevenDaysDataEffect, payload);
    yield put(getLastSevenDaysDataInSuccess({ data: data }));
  } catch (e) {
    yield put(getLastSevenDaysDataInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getAwardedBids({ payload }) {
  try {
    const { data } = yield call(getAwardedBidsEffect, payload);
    yield put(getAwardedBidsInSuccess({ data: data }));
  } catch (e) {
    yield put(getAwardedBidsInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getOpenAgingBids({ payload }) {
  try {
    const { data } = yield call(getOpenBidsAgingEffect, payload);
    yield put(getOpenBidsAgingInSuccess({ data: data }));
  } catch (e) {
    yield put(getOpenBidsAgingInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getOverallTimeline({ payload }) {
  try {
    const { data } = yield call(getOverAllTimelineEffect, payload);
    yield put(getOverallTimeLineInSuccess({ data: data }));
  } catch (e) {
    yield put(getOverallTimeLineInError({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* dashboardSaga() {
  yield takeLatest(DashboardTypes.GET_OPEN_BIDS_PROGRESS, getOpenBids);
  yield takeLatest(DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_PROGRESS, getSevenDaysData);
  yield takeLatest(DashboardTypes.GET_AWARDED_BIDS_PROGRESS, getAwardedBids);
  yield takeLatest(DashboardTypes.GET_OPEN_AGING_PROGRESS, getOpenAgingBids);
  yield takeLatest(DashboardTypes.GET_OVERALL_TIMELINE_PROGRESS, getOverallTimeline);
}
